import React, { useState,useEffect } from "react";
import "./Navbar.css";
import axios from "axios";
import { FaBars, FaTimes } from "react-icons/fa";
// import "../src/Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MdLogout } from "react-icons/md";
import { FaStepBackward } from "react-icons/fa";
import { setDivision } from "../Redux/Action/division";
import { FiHome } from "react-icons/fi";
import { FiLogOut } from "react-icons/fi";

const PosCashierNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [ModuleAccess, setModuleAccess] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const module = useSelector((state) => state.SelModule);
  const modulename = module?.selectedModule;
  const userState = useSelector((state) => state.changeTheState.user);
  const email = userState?.emailId;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
const state = useSelector((state) => state.changeTheState.user);
  const divisionState = useSelector((state) => state.changeDivision);
  const userName = state?.emailId?.split("@")[0].toUpperCase();

  const [openGroup, setOpenGroup] = useState(null);

  
 function logOut() {
    // dispatch(logIn([]));
    dispatch(setDivision(""));
    navigate("/");
  }

  const handleGroupClick = (index) => {
    setOpenGroup(openGroup === index ? null : index);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

   const handleNavigation = (page) => {
    navigate(`/${page.link}`, { state: { menu: page.menu } });
  };
  
  function AuthorizseUserLogin() {
    setIsLoading(true);
    axios
      .post(
        `${BASEURL}/getuserrights`,
        {
          EMAIL: email,
          MODULENAME: modulename,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setModuleAccess(response.data.recordsets[0]);
        setIsLoading(false);
      });
  }
  useEffect(() => {
    AuthorizseUserLogin();
  }, []);


  return (
    <nav className="centernav sticky top-0 z-[1000] bg-white">
      <div className="navbar-container_1">
        <nav className="navbar block items-center">
          <div className="block ">
            <div className="fabar" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
              {/* <FaBars /> */}
            </div>
          </div>
        
               <ul
            className={`nav-menu ${isMenuOpen ? "open" : ""}`}
            style={{ textTransform: "uppercase" }}
          >
            {/* <li className="nav-item">Men</li> */}

            <div className="hover-dropdown">
              {/* <span className="master-select-opt hover-underline-animation">
                <label className="transaction-select hover-underline-animation">
                  {ModuleAccess.length > 0 ? "Menu" : "Scanner Application"}
                </label>
              </span> */}
              <ul className="ul__list__style__scanner">
                {isloading && "Loading...."}
                {ModuleAccess.length === 0 ? (
                  <div>
                    <li>NO RIGHTS</li>
                  </div>
                ) : null}

                <aside>
                  {ModuleAccess.reduce((acc, item, index) => {
                    // Check if MENU_TYPE already exists in the accumulator
                    const existingType = acc.find(
                      (group) =>
                        group.type === item.OM_ACCOUNT_MODULE_MENU_TYPE,
                    );

                    if (existingType) {
                      // If MENU_TYPE exists, add the current ID to its list
                      if (typeof item === "object") {
                        existingType.ids.push({
                          name: item.OM_ACCOUNT_MODULE_MENU_DISPLAY_NAME,
                          link: item.OM_ACCOUNT_MODULE_WEB_PAGE,
                          menu: item.OM_ACCOUNT_MODULE_MENU,
                        });
                        existingType.weblink.push(
                          item.OM_ACCOUNT_MODULE_WEB_PAGE,
                        );
                      } else {
                        existingType.ids.push(item);
                        existingType.weblink.push(existingType.weblink[index]);
                      }
                    } else {
                      // If MENU_TYPE doesn't exist, create a new group with the current ID
                      const newId =
                        typeof item === "object"
                          ? {
                              name: item.OM_ACCOUNT_MODULE_MENU_DISPLAY_NAME,
                              link: item.OM_ACCOUNT_MODULE_WEB_PAGE,
                              menu: item.OM_ACCOUNT_MODULE_MENU,
                            }
                          : item;

                      acc.push({
                        type: item.OM_ACCOUNT_MODULE_MENU_TYPE,
                        ids: [newId],
                        weblink: [item.OM_ACCOUNT_MODULE_WEB_PAGE],
                      });
                    }
                    return acc;
                  }, []).map((group, index) => (
                    <div key={index} style={{ fontSize: "14px" }}>
                      <p
                        style={{
                          cursor: "pointer",
                          paddingBottom: "0px",
                          marginBottom: "0px",
                        }}
                        onClick={() => handleGroupClick(index)}
                      >
                        {group.type}
                      </p>

                      {openGroup === index && (
                        <ul
                          style={{ listStyleType: "none", paddingLeft: "15px" }}
                        >
                          {group.ids.map((id, idIndex) => (
                            <li key={idIndex} style={{ cursor: "pointer" }}>
                              {typeof id === "object" && (
                                <span
                                  style={{
                                    textDecoration: "none",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleNavigation(id)}
                                >
                                  {id.name}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  ))}
                </aside>
              </ul>
            </div>
            {/* Hardcoded menu at the end */}
          </ul>
        </nav>
         <div className="logedIn__as__btn">
        <p className="text-2xl italic font-bold mb-1 ml-[20px]">
          Mars Track POS CASHIER
        </p>
          <h3>Division : {divisionState ? divisionState : ""}</h3>
          <h3 className="hidden lg:block">
            {" "}
            Logged in as : {userName ? userName : "N/A"}{" "}
          </h3>
        </div>
          <aside className="flex lg:ml-24">
                 <button onClick={logOut} className="button__logout__navbar">
                   {" "}
                   LOGOUT
                 </button>
               </aside>
               <div className="logout__fullscren">
                 <button onClick={logOut} className="log__out__icon">
                   {" "}
                   <FiLogOut />
                 </button>
               </div>
        {/* <button
          className="button__logout__navbar  font-bold"
          onClick={() => navigate("/HomePage")}
        >
          <span className="text-xl">DashBoard</span>
        </button> */}
      </div>
    </nav>
  );
};

export default PosCashierNavbar;

